var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClairLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 56,
    viewBox: "0 0 200 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13707_28248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.004 0H103.984C92.0552 0.0976318 82.4143 9.73471 82.4143 21.6132V56H96.9043V42.0508H114.255V56H128.741V21.6132C128.741 9.67776 119.01 0 107.004 0ZM104.155 13.6766H107.004C110.981 13.6766 114.206 16.8618 114.247 20.8037V28.3214H96.9125V20.8037C96.9534 16.8618 100.182 13.6766 104.155 13.6766Z",
    fill: "url(#paint0_linear_13707_28248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.558 27.9675L36.4439 26.8203C34.1442 25.9742 32.3314 24.1721 31.4803 21.8858L30.3263 18.7901C30.2035 18.4606 29.733 18.4606 29.6102 18.7901L28.4562 21.8858C27.6051 24.1721 25.7923 25.9742 23.4925 26.8203L20.3785 27.9675C20.047 28.0895 20.047 28.5574 20.3785 28.6794L23.4925 29.8266C25.7923 30.6727 27.6051 32.4748 28.4562 34.761L29.6102 37.8568C29.733 38.1863 30.2035 38.1863 30.3263 37.8568L31.4803 34.761C32.3314 32.4748 34.1442 30.6727 36.4439 29.8266L39.558 28.6794C39.8895 28.5574 39.8895 28.0895 39.558 27.9675Z",
    fill: "url(#paint1_linear_13707_28248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.089 0.646973V55.9961H148.583V0.646973H134.089Z",
    fill: "url(#paint2_linear_13707_28248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5504 41.5913V0.646973H46.0563V55.9961H76.5504V41.5873H60.5504V41.5913Z",
    fill: "url(#paint3_linear_13707_28248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.423 41.5912H20.9269C16.9616 41.5464 13.7575 38.3408 13.7575 34.3868V22.2601C13.7575 18.306 16.9616 15.1004 20.9269 15.0597H39.423C39.423 15.0597 39.423 15.0556 39.423 15.0516H40.2742V0.65088H21.7412C9.73504 0.646812 0 10.3246 0 22.2601V34.3868C0 46.3222 9.73504 56 21.7412 56H40.2742V41.5952H39.423V41.5912Z",
    fill: "url(#paint4_linear_13707_28248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 22.2602C200 10.3247 190.265 0.646973 178.259 0.646973H168.569H154.075V55.9961H168.569V29.4524L184.012 55.9961H199.677C199.624 55.8659 194.472 47.4858 190.011 40.436C196.014 36.5918 199.996 29.8877 199.996 22.2602H200ZM179.482 29.4362H168.573V15.0517H169.424H179.073C188.338 15.4707 188.685 28.5127 179.482 29.4321V29.4362Z",
    fill: "url(#paint5_linear_13707_28248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13707_28248",
    x1: 105.577,
    y1: 0,
    x2: 105.577,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13707_28248",
    x1: 29.9682,
    y1: 18.543,
    x2: 29.9682,
    y2: 38.1039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13707_28248",
    x1: 141.336,
    y1: 0.646973,
    x2: 141.336,
    y2: 55.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13707_28248",
    x1: 61.3033,
    y1: 0.646973,
    x2: 61.3033,
    y2: 55.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13707_28248",
    x1: 20.1371,
    y1: 0.650879,
    x2: 20.1371,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13707_28248",
    x1: 177.037,
    y1: 0.646973,
    x2: 177.037,
    y2: 55.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13707_28248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClairLogo);
export default __webpack_public_path__ + "static/media/clair_logo.160d884635f213d5c0cf5e389247ba30.svg";
export { ForwardRef as ReactComponent };